import React from 'react'
import Button from '@mui/joy/Button';
import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/Clear';
import DropZoneInvoices from './DropZoneInvoices';
import UploadedInvoiceFiles from './UploadedInvoiceFiles';
import { Modal } from '@mui/base/Modal';
import { ModeTypes } from '../AddPurchaseOrder';
import { StyledBackdrop } from '../../../../../Users/NewAccModal';
import { FieldErrors } from '../../../../../../../domain/helpers/Errors';
import { useLanguageStore } from '../../../../../../../store/useLanguageStore';
import { useDarkModeStore } from '../../../../../../../store/useDarkModeStore';
import { ModalContent } from '../../../../../../../common/TopBar/Buttons/SearchTopBarModal';
import { darkModeBackgroud, darkModeBackgroudInputs } from '../../../../../../../utils/constants';
import { PurchaseOrderInterface } from '../../../../../../../models/ProcurementModule/PurchateOrder/PurchaseOrder';

interface InvoiceModalProps {
    mode: ModeTypes;
    form: PurchaseOrderInterface;
    errors: FieldErrors | undefined;
    purchaseOrderId: string | undefined;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    setForm: React.Dispatch<React.SetStateAction<PurchaseOrderInterface>>;
    setFileNames: React.Dispatch<React.SetStateAction<{
        fileUrl: string;
        fileName: string;
    }[]>>;
}

export const InvoiceModal: React.FC<InvoiceModalProps> = ({
    form, errors, mode,
    setOpen, setForm, setFileNames,
}) => {
    const { darkMode } = useDarkModeStore();
    const { language } = useLanguageStore();

    const isView = mode === 'View';

    return (
        <Modal
            open={true}
            onClose={() => setOpen(false)}
            slots={{ backdrop: StyledBackdrop }}
        >
            <ModalContent
                sx={{
                    width: isView ? 400 : 850,
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    backgroundColor: darkMode ? darkModeBackgroud : 'white',
                    zIndex: 1300,
                }}
            >
                <div>
                    <div className="d-flex flex-row align-items-center ps-3 pe-3 pt-3">
                        <h4 className={`${darkMode ? 'text-white' : 'text-muted'} text-truncate`} style={{ maxWidth: 800 }}>
                            {language['Invoices']}
                        </h4>
                        <IconButton
                            aria-label="Close Modal"
                            title={language['Close']}
                            size="small"
                            color="default"
                            className="ms-auto"
                            onClick={() => setOpen(false)}
                        >
                            <ClearIcon />
                        </IconButton>
                    </div>

                    <hr className={`m-0 mt-2 p-0 ${darkMode && 'text-white opacity-100'}`} />
                    <div className="p-4 position-relative d-flex flex-row gap-3 justify-content-between">
                        {!isView &&
                            <DropZoneInvoices
                                form={form}
                                errors={errors}
                                setForm={setForm}
                                setFileNames={setFileNames}
                            />}
                        <UploadedInvoiceFiles
                            mode={mode}
                            form={form}
                            errors={errors}
                            setForm={setForm}
                        />
                    </div>

                    <hr className={`m-0 p-0 ${darkMode && 'text-white opacity-100'}`} />

                    <div className="d-flex align-items-center justify-content-end p-2 mt-2 gap-2">
                        <Button
                            className="w-25 fw-bold"
                            sx={{
                                fontSize: "14px",
                                background: darkMode ? darkModeBackgroudInputs : "white",
                                border: `1px solid var(--btn-color)`,
                                color: darkMode ? 'white' : "var(--btn-color)",
                                "&:hover": {
                                    background: darkMode ? darkModeBackgroudInputs : "white",
                                    opacity: .7,
                                },
                            }}
                            onClick={() => setOpen(false)}
                        >
                            {language["Cancel"]}
                        </Button>
                    </div>
                </div>
            </ModalContent>

        </Modal>
    );
}
export default InvoiceModal